// extracted by mini-css-extract-plugin
export var categoryIcon = "_bv-5";
export var connectorContainer = "_bv-1";
export var connectorLine = "_bv-0";
export var minHeight0 = "_bv-6";
export var relativeUnitValueSelector = "_bv-2";
export var trifoldSelectorBody = "_bv-4";
export var trifoldSelectorList = "_bv-3";